// Mission XP. A mission is worth 100 XP and a final challenge 500 XP. Since hint pricing was added
// (records completed with xpRule 2), each lab-coach hint used costs 10 XP (25 XP in a final
// challenge), but a mission never pays less than half. Missions completed before that keep full XP.
// XP is always derived from the stored completion record — never stored or sent separately.
export const HINT_XP_RULE = 2;
export const BASE_XP = { MISSION: 100, CHALLENGE: 500 };
export const HINT_COST = { MISSION: 10, CHALLENGE: 25 };

const kindKey = (kind) => (kind === 'CHALLENGE' ? 'CHALLENGE' : 'MISSION');
export const hintCost = (kind) => HINT_COST[kindKey(kind)];
export const baseXp = (kind) => BASE_XP[kindKey(kind)];

/** XP a mission is worth with `hints` hints used (never below half). */
export function xpWithHints(kind, hints = 0) {
  const base = baseXp(kind);
  return Math.max(base / 2, base - Math.max(0, Number(hints) || 0) * hintCost(kind));
}

/**
 * Incident Labs (src/incidents/): an incident earns XP once, for the first solve the server
 * verified, on the same rule as a mission — 100 XP, −10 per coach hint, never below 50.
 * Practice runs after that earn nothing (there is one verified record per incident).
 */
export const incidentXp = (hints = 0) => xpWithHints('INCIDENT', hints);

/** XP earned by one completed unit record. */
export function unitXp(kind, record) {
  if (!record || record.status !== 'complete') return 0;
  return record.xpRule === HINT_XP_RULE ? xpWithHints(kind, record.hints) : baseXp(kind);
}
